module.exports = __webpack_public_path__ + "img/goods4_5.bba827a3.jpg";